import { render, staticRenderFns } from "./types-search.vue?vue&type=template&id=b6cff49c&"
import script from "./types-search.vue?vue&type=script&lang=js&"
export * from "./types-search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports